import { appliancesProducts } from "./appliancesProducts";
import { carsProducts } from "./carsProducts";
import { clothingProducts } from "./clothingProducts";
import { collaborationProducts } from "./collaborationProducts";
import { drinksProducts } from "./drinksProducts";
import { electronicsProducts } from "./electronicsProducts";
import { fastFoodProducts } from "./fastFoodProducts";
import { foodAndSnacksProducts } from "./foodAndSnacksProducts";
import { hardwareProducts } from "./hardwareProducts";
import { householdProducts } from "./householdProducts";
import { messagingProducts } from "./messagingProducts";
import { officeProducts } from "./officeProducts";
import { personalCareProducts } from "./personalCareProducts";
import { servicesProducts } from "./servicesProducts";
import { socialMediaProducts } from "./socialMediaProducts";
import { streamingProducts } from "./streamingProducts";
import { travelProducts } from "./travelProducts";

// TODO database?
export const getAllProductsAndBrands = () => {
  return [
    ...socialMediaProducts,
    ...messagingProducts,
    ...collaborationProducts,
    ...streamingProducts,
    ...servicesProducts,
    ...travelProducts,
    ...carsProducts,
    ...clothingProducts,
    ...appliancesProducts,
    ...electronicsProducts,
    ...fastFoodProducts,
    ...foodAndSnacksProducts,
    ...drinksProducts,
    ...personalCareProducts,
    ...householdProducts,
    ...hardwareProducts,
    ...officeProducts
  ];
}










// Unilever (UK)
//   Dove

// Colgate-Palmolive (US)

  /*
Ireland

Soft drinks - Cidona, Club, TK red lemonade

For fast food you can add in Apache Pizza and Shake Dog.

Shake Dog is a split off chain of Eddie Rockets after the franchise holder in the southern part of the country fell out with the franchise owner. The restaurants are identical except where Eddie Rockets uses red, Shake Dog uses blue.

I've just seen that we can add to the list. Just added my suggestions. Great idea op.
  */
  